/**
 * 环比变化柱状图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const chainChangeBarValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'string', required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'y1', type: 'number', required: true }
  ],
  businessRules: [
    {
      name: 'chain-change-bar-sufficient-data',
      validator: data => Array.isArray(data) && data.length >= 2,
      message: 'Chain change bar chart requires at least 2 data points for comparison',
      suggestion: 'Provide at least 2 data points to show meaningful period-over-period changes',
      severity: 'warning'
    },
    {
      name: 'chain-change-bar-valid-comparison',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        // 检查是否有有效的对比数据（y1不全为0或null）
        return data.some(item => {
          const y1Value = item[encoding?.y1 as string];
          return y1Value != null && Number(y1Value) !== 0;
        });
      },
      message:
        'Chain change bar chart should have valid comparison values (y1) for meaningful analysis',
      suggestion: 'Ensure y1 field contains non-zero baseline values for comparison',
      severity: 'warning'
    }
  ]
};
